import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { MessageRequest } from '../../../../model/message-request.model';
import { ComplyMessageService } from '../../../../services/comply-message.service';
@Component({
    templateUrl: './send-message-modal.component.html',
    styleUrls: ['./send-message-modal.component.scss']
})
export class SendMessageModalComponent implements OnInit {
    @Input() target: number;
    @Input() typeId: string;
    @Input() typeIds: Array<string>;

    messageForm: UntypedFormGroup;
    busy: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private complyMessageService: ComplyMessageService
    ) {}

    ngOnInit() {
        this.busy = false;
        let ids:string[] = new Array<string>();
        ids = this.typeIds ? this.typeIds : [this.typeId]
        this.messageForm = this.formBuilder.group({
            Message: [null, [Validators.required]],
            Target: [this.target, [Validators.required]],
            Type: [1, [Validators.required]],
            TypeID: [ids, [Validators.required]]
        });
    }

    send({ value, valid }: { value: MessageRequest, valid: boolean}) {
        if (valid && !this.busy) {
            this.busy = true;
            // convert to array
            /*
            let typeID:string = value.TypeID;
            value.TypeID = new Array<string>();
            value.TypeID.push(typeID);
            */
            this.complyMessageService
                .sendMessage(value)
                .pipe(
                    finalize(() => this.busy = false)
                )
                .subscribe(() => {
                    this.activeModal.close();
                });
        }
    }

    cancel() {
        this.activeModal.dismiss();
    }
}